import { Component, OnDestroy, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import {
  faAngleLeft,
  faAngleRight,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faEdit,
  faFileExport,
  faInfoCircle,
  faLink,
  faLock,
  faPlus,
  faProjectDiagram,
  faRedo,
  faSave,
  faSearch,
  faStepBackward,
  faStepForward,
  faTasks,
  faTimes,
  faTrashAlt,
  faUser,

} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { InteractionMapperComponent } from '../interaction-mapper/interaction-mapper.component';
import { PlannerComponent } from '../planner/planner.component';
import { faConnectdevelop, faJira } from '@fortawesome/free-brands-svg-icons';
declare var $: any;
import { UserManagementService } from '../shared/services/user-management.service';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-sprint-planner',
  templateUrl: './sprint-planner.component.html',
  styleUrls: ['./sprint-planner.component.scss']
})
export class SprintPlannerComponent implements OnInit, OnDestroy {
  /// icons

  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  faConnectdevelop = faConnectdevelop;
  faLink = faLink;
  faTrashAlt = faTrashAlt;
  faCircle = faCircle;
  faCheckCircle = faCheckCircle;
  faRedo = faRedo;
  faSave = faSave;
  faPlus = faPlus;
  faSearch = faSearch;
  faLock = faLock;
  faTimes = faTimes;
  faEdit = faEdit;
  faTasks = faTasks;
  faJira = faJira;
  clickEventsubscriptionSocket: Subscription;
  proDataSubscription: Subscription = new Subscription();
  jiraDataSubscription: Subscription = new Subscription();
  modelData: any;
  jiraProjectData: any;

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private reloadToolService: ReloadToolService,
    private Config: Config,
    private appService: AppService,
    public mainComponent: MainComponent,
    public plannerComponent: PlannerComponent,
    public interactionMapperComponent: InteractionMapperComponent,
    private userManagementService: UserManagementService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
  }


  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  /// app code open

  planner: any;
  listOfEUTs: any;
  listOfAttributes: any;
  listOfEnv: any;
  projectUserList: any;
  EUTdetails: any;
  entityModel: any;
  sprintTasks: any;
  appConstlistOfAttributes: any;
  scopeMap: any;
  scenarios: any;
  runinfo: any;
  eutFound: any;
  // AppService: any;
  userDetails: any;
  ProjectService: any;
  interactionMap: any;
  suites: any;
  checklists: any;
  personaMap: any;

  /// app code
  /// model variables open

  model: any = {
    listOfEUTs: '',
    EUTdetails: '',
    scopeMap: '',
    interactionMap: '',
    personaMap: '',
    entityModel: '',
    listOfAttributes: '',
    scenarios: '',
    listOfEnv: '',
    projectUserList: '',
    tasks: '',
    sprintTasks: [],
    checklists: '',
    appConstlistOfAttributes: '',
    AppService: '',
    planner: '',
    suites: '',
    delTaskDetails: '',
    totalEnvs: [],
    choosenEntity: '',
    entityTypes: ['TF', 'UR', 'BF'],
    mappedEntities: [],
    mappedEntitiesChoosen: [],
    taskID: '',
    taskIndex: '',
    matchedTaskEntity: {}
  };

  /// model vaiables close

  /// ctrl vars
  index: any;
  entityName: any;
  selectedEntity: any = { ename: '' };
  selectedEntityId: any;
  eutTypes: any;
  activityTypes: any;
  activityDisabled: any;
  selectedEUT: any;
  selectedActivity: any;
  selectedActivityObj: any;
  selectedAttribute: any;
  attributeSelected: any;
  selectedEnvironment: any;
  selectedSuite: any;
  selectedSuiteName: any;
  freeFormTestData: any;
  selectedChecklist: any;
  publicChecklists: any;
  testTypes: any;
  selectedPerson: any = '';
  sprintName: any = '';
  userstoryName: any = '';
  sprintID: any = '';
  modalPlannerName: any = '';
  toastMsg: any = '';
  newTaskDetails: any = {};
  editTaskDetails: any = {};
  delTaskDetails: any = {};
  ModifiedTaskDetails: any = {};
  taskSelectedForModify: any = false;
  taskCombineId: any = '';
  taskID: any = '';
  finalTaskList: any = '';
  taskPlanner: any = '';
  planDropdown: any = false;
  planName: any = true;
  AttPlus: any = 1;
  EnvPlus: any = 1;

  mytaskPlannerList: any = [];
  userIDTemp: any = localStorage.getItem('userID');
  currentProjectID: any = localStorage.getItem('projectID');
  fieldsDisabled: any = true;
  plannerPlusBtn: any = false;
  planNameField: any = false;
  showText: any = false;
  updateSprintname: any = false;
  new: any = true;
  singleSelectedAttribute: any = '';
  singleEnvironmentName: any = '';
  sprintNamesArray: any = [];
  tempSprintNamesArray: any = [];
  checkListArray: any = [];
  tempChecklistNames: any = [];
  attrDisabled: any = false;
  selectEnvSubstr: any = '';
  envMapArrayList: any = [];
  hideEUTDD: any = false;
  hideClistDD: any = true;
  hideEnvDD: any = true;
  hideSuitesDD: any = true;
  hideFTField: any = true;
  personName: any;
  matchedAttribute: any;
  selectedAttributesymbol: any;
  envDDDisabled: any;
  oldSprintName: any;
  tempPlanWithID: any;
  EUTTypeDDisabled: any;
  EUTDDisabled: any;
  updatedTaskList: any;
  attributeName: any;
  environmentName: any;
  mapText: any;
  selectedTaskId: any;
  matchedScenario: any;
  matchedRuninfo: any;
  taskIndex: any;
  choosenEntity: any;
  mappedEntitiesChoosen: any;
  mappedEntities: any;
  entityTypes: any;
  matchedTaskEntity: any;
  toastMsgPopup: any;
  searchText: any;
  checksearchText: any;
  eutsearchText: any;


  step: string = '1';
  paramsSubscription: Subscription = new Subscription();
  selectedAttributesArray: string[] = [];
  selectedImpactEntitesArray: any = [];
  config: any;
  attribute: any = [];
  userstoryNameImpact: string = '';

  ngOnInit(): void {
    setTimeout(() => {
      this.getVideoURL('Tp1');
    }, 2000);
    this.step = this.route.snapshot.queryParams['step'];
    this.paramsSubscription = this.route.queryParams
      .subscribe(
        (params: Params) => {
          this.step = params['step'];
        });
    if (this.step === '2' || this.step === '3') {
      if (!this.selectedEntity.eID) {
        this.nextStep('1');
      }
    }
    this.proDataSubscription = this._sharedService.projectJsonSubject.subscribe(data => {
      this.modelData = data.model;
    });
    this.jiraDataSubscription = this._sharedService.jiraProDataSubject.subscribe(stories => {
      this.jiraProjectData = stories;
      console.log('jiraProjectData in sprint', this.jiraProjectData);
    });

    this.eutTypes = ['TF', 'UR', 'BF'];
    this.selectedEUT = 'TF';
    this.config = this.Config;
    this.activityTypes = [
      { type: 'TN', name: 'NEW', shortfoam: 'New' },
      { type: 'RF', name: 'FIX', shortfoam: 'Fix' },
      { type: 'RM', name: 'MOD', shortfoam: 'Mod' },
      // { type: 'CL', name: 'Run-Checklist', shortfoam: 'Clist' },
      // { type: 'RS', name: 'Run-Suite', shortfoam: 'Suite' },
      // { type: 'FT', name: 'Do', shortfoam: 'Do' },
    ];
    this.sprintTasks = this.modelData.sprintTasks;
    this.loadSprintNamesList(this.sprintTasks);
    this.changeActivity({ type: 'TN', name: 'NEW', shortfoam: 'New' });

  }

  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
    this.proDataSubscription.unsubscribe();
  }

  getVideoURL(urlName: any) {
    var videoURL = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, (iframe) => {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'stopVideo',
        }),
        '*'
      );
    });
  }

  mapImpactedEUTs() {
    console.log("IM", this.selectedImpactEntitesArray);
    console.log("EUT", this.selectedEntity);
    for (var i = 0; i < this.selectedImpactEntitesArray.length; i++) {
      console.log(this.selectedImpactEntitesArray[i]);
      let obj = {
        "eut2": this.selectedEntity.eID,
        "eut1": this.selectedImpactEntitesArray[i].eID
      }
      this.modelData.interactionMap.push(obj);
    }
  }
  // mapping EUt to eut 
  mapEutToEut(eut: any, isChecked: any) {
    isChecked
      ? this.addEUT(eut, this.selectedEntity)
      : this.deleteEUT(eut, this.selectedEntity);
  }
  addEUT(eID: any, eut: any) {
    // console.log(eID, eut);
    this.modelData.interactionMap.push({ eut2: eID, eut1: eut.eID });
    // console.log('Imap', this.modelData.interactionMap);
  }

  deleteEUT(eID: any, eut: any) {
    var index = this.modelData.interactionMap.findIndex(
      (map: any) => map.eut1 == eut.eID && map.eut2 == eID
    );
    if (index > -1) {
      this.modelData.interactionMap.splice(index, 1);
    }
  }

  //Check whether the eut in list is present in the interaction mapping for the choosen eut
  isCheckedInter(eut: any) {
    if (this.modelData.interactionMap.length > 0) {
      var a = this.modelData.interactionMap.findIndex((a: any) => a.eut2 == eut.eID);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }
  generateReport(auto: any) {
    // window.localStorage.setItem('selectedPlanname', this.sprintName);
    // let mapperArray = ['Task Planner'];
    // window.localStorage.setItem('exportedData', JSON.stringify(mapperArray));
    // window.localStorage.setItem(
    //   'scenarioEntity',
    //   JSON.stringify(['TF', 'UR', 'BF'])
    // );
    // if (auto == 'true') {
    //   window.open('/exportReport', '_blank');
    //   window.localStorage.setItem('autoDownload', 'true');
    // }
  }

  loadSprintNamesList(sprintTasks: any) {
    this.tempPlanWithID = [];
    this.sprintNamesArray = [];
    this.tempSprintNamesArray = [];
    for (var t = 0; t < sprintTasks.length; t++) {
      if (
        sprintTasks[t].sprintName != '' &&
        sprintTasks[t].sprintName != undefined &&
        sprintTasks[t].sprintName != null
      ) {
        this.tempSprintNamesArray.push(sprintTasks[t].sprintName);
      }
      if (t == sprintTasks.length - 1) {
        this.tempSprintNamesArray = this.getUnique(this.tempSprintNamesArray);
        for (var p = 0; p < this.tempSprintNamesArray.length; p++) {
          var tempPlan: any = {};
          tempPlan.sprintName = this.tempSprintNamesArray[p];
          var tempPlanIDFound = this.sprintTasks.find(
            (task: any) => task.sprintName == this.tempSprintNamesArray[p]
          );
          tempPlan.plan_id = tempPlanIDFound.plan_id;
          this.sprintNamesArray.push(tempPlan);
        }
      }
    }
  }

  getUnique(array: any) {
    var uniqueArray = [];
    // Loop through array values
    if (array) {
      for (var i = 0; i < array.length; i++) {
        if (uniqueArray.indexOf(array[i]) === -1) {
          uniqueArray.push(array[i]);
        }
      }
    }
    return uniqueArray;
  }

  selectedSprint(newButton: any, textBox: any, sprintName: any) {
    console.log('this.sprintName', sprintName);
    if (this.updateSprintname == true) {
      this.loadSprintNamesList(this.sprintTasks);
    }

    if (sprintName != '') {
      var planIDFound = this.sprintNamesArray.find(
        (plan: any) => plan.sprintName == sprintName
      );
      if (planIDFound) {
        this.sprintID = planIDFound.plan_id;
      }
    } else if (sprintName != '') {
      this.sprintID = '';
    }
    this.oldSprintName = this.sprintName;
    this.updateSprintname = false;
    this.sprintName = sprintName;
    this.new = newButton;
    this.showText = textBox;
  }

  clear() {
    this.showText = false;
    if (this.updateSprintname == true) {
      this.sprintName = this.oldSprintName;
      this.updateSprintname == false;
    } else if (this.updateSprintname == false) {
      if (this.oldSprintName != '') {
        this.sprintName = this.oldSprintName;
        this.selectedSprint(false, false, '');
      } else {
        this.sprintName = this.oldSprintName;
        this.selectedSprint(false, false, '');
      }
    }
  }

  sprintNameChanged(newname: any, oldname: any, updatePlanname: any) {
    // if (newname != '') {
    //   let planExist = this.sprintNamesArray.find(
    //     (plan: any) => plan.plan_name.toUpperCase() == newname.toUpperCase()
    //   );
    //   if (planExist) {
    //     this.triggerToastPopup(this.appService.getResourceText('V019'));
    //   } else {
    if (updatePlanname == true) {
      var planNameDetails: any = {};
      planNameDetails.projectId = window.localStorage.getItem('projectID');

      for (var i = 0; i < this.modelData.sprintTasks.length; i++) {
        if (this.modelData.sprintTasks[i].sprintName == oldname) {
          this.modelData.sprintTasks[i]['sprintName'] = newname;
        }
      }
      planNameDetails.tasks = this.modelData.sprintTasks;
      this.ProjectServices.planNameUpdate(planNameDetails).subscribe(
        (response: any) => {
          console.log('getUsersFromProject res', response);
          if (response.statusCode == 200) {
            this.selectedSprint(false, false, newname);
            // this.plannerComponent.loadMytasksList(this.modelData.tasks);
            this.reloadToolService.triggerToolSprint(this.sprintTasks);

          } else {
          }
        }
      );
    } else {
      this.resetSprintField(newname, this.uuidv4());
    }
    // this.resetTaskData();
    //   }
    // } else if (newname == '') {
    //   this.triggerToastPopup(this.appService.getResourceText('V019a'));
    //   return;
    // }
  }

  triggerToastPopup(message: any) {
    this.toastMsgPopup = message;
    $('#taskPlannerMsgPopup1').modal('toggle');
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  resetSprintField(newname: any, planID: any) {
    this.fieldsDisabled = false;
    this.showText = false;
    this.new = false;
    this.sprintName = newname;
    this.sprintID = planID;
    this.updateSprintname = false;
  }

  editSprintname(oldName: any) {
    this.showText = true;
    this.updateSprintname = true;
    this.oldSprintName = oldName;
  }

  changeEntity(eType: string) {
    console.log('etype', eType);
    this.selectedEUT = eType;
    this.index = this.eutTypes.findIndex((type: any) => type == eType);
  }

  mapEutToAtt(symbol: string, check: boolean) {
    check
      ? this.addAttr(symbol)
      : this.deleteAttr(symbol);
  }

  addAttr(att: any) {
    this.selectedAttributesArray.push(att);
  }

  deleteAttr(att: any) {
    var index = this.selectedAttributesArray.findIndex(
      (map: any) => map.symbol == att.symbol
    );
    if (index > -1) {
      this.selectedAttributesArray.splice(index, 1);
    }
  }


  mapEutToImpact(entity: any, check: boolean) {
    check
      ? this.addImpact(entity)
      : this.deleteImpact(entity);
  }
  addImpact(ent: any) {
    this.selectedImpactEntitesArray.push(ent);
  }

  deleteImpact(ent: any) {
    var index = this.selectedImpactEntitesArray.findIndex(
      (map: any) => map.eID == ent.eID
    );
    if (index > -1) {
      this.selectedImpactEntitesArray.splice(index, 1);
    }
  }

  //Check whether the attribute in list is present in the scope map for the choosen eut
  isCheckedAtt(attribute: any) {
    if (this.selectedAttributesArray.length > 0) {
      var a = this.selectedAttributesArray.findIndex((a: any) => a == attribute.symbol);
      return a > -1 ? true : false;
    } else {
      return false;
    }
  }

  changeActivity(activity: any) {
    // console.log('activity', activity);
    this.selectedActivityObj = activity;
    this.selectedActivity = activity.shortfoam;
    if (
      activity.type == 'TN' ||
      activity.type == 'RF' ||
      activity.type == 'RM'
    ) {
      this.changeEntity('TF');
    }
  }

  nextStep(stepNumber: string) {
    this.router.navigate([], {
      queryParams: {
        'step': stepNumber
      },
      queryParamsHandling: 'merge'
    })
  }


  addTaskToPlanner() {
    console.log('this.editTaskDetails', this.editTaskDetails);
    // if (this.editTaskDetails.activity) {
    //   if (this.editTaskDetails.activity.type == 'RI') {
    //     let updateObj = {
    //       attribute: this.selectedAttribute,
    //       attributeSymbol: this.selectedAttributesymbol,
    //       environment: this.selectedEnvironment,
    //       assignedID: this.selectedPerson,
    //       assignedUser: this.personName,
    //     };
    //     this.updateImpactedEntityTask(this.editTaskDetails, updateObj);
    //     this.editTaskDetails = '';
    //     this.selectedActivity = 'New';
    //     this.selectedActivityObj = {
    //       type: 'TN',
    //       name: 'Test-NEW',
    //       shortfoam: 'New',
    //     };
    //     this.tableCollapseExpand();
    //     this.resetTaskDetails(true);
    //     return;
    //   } else if (
    //     this.editTaskDetails.activity.type == 'RF' ||
    //     this.editTaskDetails.activity.type == 'RM'
    //   ) {
    //     if (
    //       this.editTaskDetails.entity_Id != this.selectedEntityId ||
    //       this.editTaskDetails.attribute != this.selectedAttribute
    //     ) {
    //       this.deleteTaskFromPlannerList(this.editTaskDetails, true);
    //     } else {
    //       this.updateModifyOrFixTask(
    //         this.editTaskDetails,
    //         this.selectedEnvironment,
    //         this.personName,
    //         this.selectedPerson
    //       );
    //       this.tableCollapseExpand();
    //       this.resetTaskDetails(true);
    //       this.loadSprintNamesList(this.tasks);
    //       return;
    //     }
    //   } else {
    //     // this.deleteTaskFromPlannerList(this.editTaskDetails, true);
    //   }
    // }
    if (this.sprintName == '') {
      this.triggerToastPopup(this.appService.getResourceText('V014'));
      return;
    }
    if (
      this.selectedActivityObj.type == 'TN' ||
      this.selectedActivityObj.type == 'RF' ||
      this.selectedActivityObj.type == 'RM'
    ) {
      if (this.selectedAttributesArray.length === 0) {
        this.triggerToastPopup(this.appService.getResourceText('V016'));
        return;
      }
    }
    this.newTaskDetails.task_desc = '';
    this.newTaskDetails.attributes = this.selectedAttributesArray;
    this.newTaskDetails.entity_Id = this.selectedEntityId == undefined ? this.selectedEntityId = this.uniqueID(this.selectedEUT) : this.selectedEntityId == this.selectedEntityId;
    this.newTaskDetails.entity_desc = this.userstoryName;
    this.newTaskDetails.entityType = this.selectedEUT;
    // this.newTaskDetails.plan_name = this.plannerName;
    // this.newTaskDetails.plan_id = this.plannerID;
    // if (this.selectedPerson == 'not assigned' || this.selectedPerson == '') {
    //   this.selectedPerson = 'not assigned';
    //   this.personName = 'not assigned';
    //   this.newTaskDetails.status = 0;
    // } else {
    //   this.newTaskDetails.status = 1;
    // }
    // this.newTaskDetails.assignedto = this.selectedPerson;
    // this.newTaskDetails.assigneduser = this.personName;
    this.newTaskDetails.activity = this.selectedActivityObj;
    // if (this.selectedActivityObj.type == 'FT') {
    //   if (this.freeFormTestData == '') {
    //     this.triggerToastPopup(this.appService.getResourceText('V020c'));
    //     return;
    //     // return -1; //// commented temporarily
    //   } else {
    //     this.newTaskDetails.task_desc = this.freeFormTestData;
    //   }
    // }
    // if (this.selectedActivityObj.type == 'RS') {
    //   if (this.selectedSuite.suiteName === undefined) {
    //     this.triggerToastPopup(this.appService.getResourceText('V020b'));
    //     return;
    //   } else {
    //     this.newTaskDetails.selectedSuite = this.selectedSuite;
    //   }

    // }
    // if (this.selectedActivityObj.type == 'CL') {
    //   if (this.selectedChecklist.checklistId === undefined) {
    //     this.triggerToastPopup(this.appService.getResourceText('V020a'));
    //     return;
    //   } else {
    //     this.newTaskDetails.checklistDetails = this.selectedChecklist;
    //   }
    // }
    console.log(this.checkEUTExists(this.newTaskDetails));

    if (this.checkEUTExists(this.newTaskDetails) === true) {
      this.triggerToastPopup(this.appService.getResourceText('V031'));
      return;
    } else {
      this.checkTaskExists(this.newTaskDetails, this.editTaskDetails);
    }
    // this.tableCollapseExpand();
    // this.loadSprintNamesList(this.tasks);
    // this.plannerComponent.loadMytasksList(this.tasks);
    this.reloadToolService.triggerToolSprint(this.sprintTasks);
    console.log('newTaskDetails', this.newTaskDetails);
    // new entity add/update/duplicate check in landscape to be dine here
    // scope mapping to be done for selected attributes
    // tasks to be created for new/existing user story and assigned to self(who created)

  }
  checkEUTExists(newTaskDetails: any) {
    console.log(newTaskDetails);
    console.log("EUT", this.modelData.listOfEUTs);
    this.eutFound = this.modelData.listOfEUTs.find(
      (eut: any) => eut.eName == newTaskDetails.entity_desc
    );
    console.log("founfd", this.eutFound);
    if (this.eutFound) {
      return true;
    } else {
      return false;
    }
  }

  checkTaskExists(newTaskDetails: any, editTaskDetails: any) {
    var taskCombineUUID: any = this.uuidv4();
    // }
    var taskCreateArray: any = '';
    // if (this.newTaskDetails.activity.type == 'TN') {
    //   taskCreateArray = ['dd'];
    // } else if (this.newTaskDetails.activity.type == 'RM') {
    //   taskCreateArray = ['dd'];
    // } else if (this.newTaskDetails.activity.type == 'RF') {
    //   taskCreateArray = ['dd'];
    // }
    // this.createTask(this.newTaskDetails, this.editTaskDetails, taskCombineUUID, taskCreateArray,this.newTaskDetails.attributes[0]);
    // if (this.newTaskDetails.attributes.length > 1) {
    for (var i = 0; i < this.newTaskDetails.attributes.length; i++) {
      if (i == 0) {
        taskCreateArray = ['im', 'dd', 'de', 'ex'];
      } else {
        taskCreateArray = ['de', 'ex'];
      }
      this.createTask(this.newTaskDetails, this.editTaskDetails, taskCombineUUID, taskCreateArray, this.newTaskDetails.attributes[i]);
      this.updateScopeMap(newTaskDetails, this.newTaskDetails.attributes[i]);
    }
    // }
    //  console.log("Scope",taskCreateArray);
    //  return;

    //Adding userstory/EUT to the eutlist
    var obj = {
      "eID": newTaskDetails.entity_Id,
      "eName": newTaskDetails.entity_desc,
      "eType": newTaskDetails.entityType,
      "scenarioCount": 0
    }
    this.modelData.listOfEUTs.unshift(obj);
    // this.tableCollapseExpand();
    // this.resetTaskDetails(false);
  }
  createTask(taskDetails: any, editDetails: any, taskCombineUUID: any, taskCreateArray: any, attributes: any) {
    // console.log('taskDe', taskDetails);
    // return;
    // console.log("this.model.tasks",this.model.tasks);
    // for (var k = 0; k < this.model.sprintTasks.length; k++) {
    //   if (this.model.sprintTasks[k].sprintName == taskDetails.sprintName) {
    //     if (
    //       taskDetails.activity.type == 'TN' ||
    //       taskDetails.activity.type == 'RM' ||
    //       taskDetails.activity.type == 'RF'
    //     ) {
    //       if (
    //         this.model.sprintTasks[k].activity.type == 'TN' ||
    //         this.model.sprintTasks[k].activity.type == 'RM' ||
    //         this.model.sprintTasks[k].activity.type == 'RF'
    //       ) {
    //         if (
    //           this.model.sprintTasks[k].sprintName == taskDetails.sprintName &&
    //           this.model.sprintTasks[k].entity_Id == taskDetails.entity_Id &&
    //           this.model.sprintTasks[k].attributes[0].symbol == taskDetails.attributes[0].symbol &&
    //           taskDetails.activity.type == this.model.sprintTasks[k].activity.type
    //         ) {
    //           this.triggerToastPopup(this.appService.getResourceText('V020'));
    //           return;
    //         }
    //       }
    //     }
    //   }
    // }
    // if (editDetails.task_combine_id) {
    //   var taskCombineUUID = editDetails.task_combine_id;
    // } else {

    //  else if (taskDetails.activity.type == 'FT') {
    //   this.generateFreeFormTask(taskDetails);
    // } else if (taskDetails.activity.type == 'RS') {
    //   this.generateRunSuiteTask(taskDetails);
    // } else if (taskDetails.activity.type == 'CL') {
    //   this.generateRunChecklistTask(taskDetails);
    // }

    for (var i = 0; i < taskCreateArray.length; i++) {
      var taskDesc = '';
      var toolType = '';
      var createTask = true;
      if (taskCreateArray[i] == 'im') {
        // let entityFound = this.model.interactionMap.find(
        //   (inter: any) => inter.eut2 == taskDetails.entity_Id
        // );
        // if (entityFound) {
        //   createTask = false;
        // }
        toolType = 'im';
        taskDesc =
          'Map interactions for ' +
          taskDetails.entityType +
          " - '" +
          taskDetails.entity_desc +
          "'";
      } else if (taskCreateArray[i] == 'dd') {
        // let ddFound = this.model.EUTdetails.find(
        //   (eut: any) => eut.eID == taskDetails.entity_Id
        // );
        // if (ddFound) {
        //   createTask = false;
        // }
        toolType = 'dd';
        taskDesc = "Deep dive into '" + taskDetails.entity_desc + "'";
      } else if (taskCreateArray[i] == 'de') {
        // let ddFound = this.model.scenarios.find(
        //   (scen: any) =>
        //     scen.eID == taskDetails.entity_Id &&
        //     scen.tID == taskDetails.attributeSymbol
        // );
        // if (ddFound) {
        //   createTask = false;
        // }
        toolType = 'de';
        taskDesc =
          'Design for ' +
          attributes.name +
          " - '" +
          taskDetails.entity_desc +
          "'";
      } else if (taskCreateArray[i] == 'ex') {
        // if (taskDetails.environment) {
        //   taskDesc =
        //     taskDetails.activity.name +
        //     " '" +
        //     taskDetails.entity_desc +
        //     "' for " +
        //     taskDetails.attribute +
        //     ' on ' +
        //     taskDetails.environment;
        // } else {
        taskDesc =
          taskDetails.activity.name +
          " '" +
          taskDetails.entity_desc +
          "' for " +
          attributes.name;
        // }
        toolType = 'ex';
      }
      if (createTask == true) {
        // console.log("taskDesc", taskDesc);
        this.createTaskObj(taskCombineUUID, taskDetails, taskDesc, toolType, attributes);
      }
    }
  }

  createTaskObj(
    taskCombineUUID: any,
    taskDetails: any,
    taskDesc: any,
    toolType: any,
    attributes: any
  ) {
    // var taskDesc = "Do Design " + taskDetails.entity_desc + " for " + taskDetails.attribute;
    this.userDetails = window.localStorage.getItem("loginDetails");
    var user = JSON.parse(this.userDetails)
    var taskObj: any = {};
    taskObj.status = 1;
    taskObj.task_desc = taskDesc;
    taskObj.toolType = toolType;
    taskObj.task_combine_id = taskCombineUUID;
    taskObj.assignedto = user.userId;
    taskObj.assigneduser = user.user_display_name;
    // console.log("ATTR", attributes);
    taskObj.attributes = attributes;
    taskObj.activity = taskDetails.activity;
    // if (taskDetails.environment) {
    //   taskObj.environment = taskDetails.environment;
    // } else {
    //   taskObj.environment = '';
    // }
    taskObj.sprintName = this.sprintName;
    taskObj.sprintID = this.sprintID;
    taskObj.entity_Id = taskDetails.entity_Id;
    taskObj.entity_desc = taskDetails.entity_desc;
    taskObj.entityType = taskDetails.entityType;
    taskObj.completed = false;
    taskObj.taskId = this.uuidv4();
    taskObj.createdOn = new Date();
    // console.log("A", this.model.sprintTasks);
    // console.log("B", taskObj);
    this.modelData.sprintTasks.push(taskObj);
    console.log("this.model.sprintTasks", this.modelData.sprintTasks);
    this.resetTaskData();
  }

  //Adding EUT from impacted new
  addEUTToImpact() {
    this.eutFound = this.modelData.listOfEUTs.find(
      (eut: any) => eut.eName == this.userstoryNameImpact
    );
    console.log("founfd", this.eutFound);
    var found = false;
    if (this.eutFound) {
      found = true;
    } else {
      found = false;
    }
    if (found == false) {
      var obj = {
        "eID": this.uniqueID(this.selectedEUT),
        "eName": this.userstoryNameImpact,
        "eType": this.selectedEUT,
        "scenarioCount": 0
      }
      this.modelData.listOfEUTs.unshift(obj);
      this.resetImpactedTaskData();
    }
  }
  //Updating scope map on task create
  updateScopeMap(taskDetails: any, attributes: any) {
    // console.log("TSK",taskDetails);
    // console.log("Attr",attributes);
    // console.log("sc",this.modelData.scopeMap);
    var scope = {
      "aType": attributes.symbol,
      "eID": taskDetails.entity_Id
    }
    this.modelData.scopeMap.push(scope);
  }

  loadEntityDetails(entity: any) {
    if (entity) {
      this.selectedEntity = entity;
      this.selectedAttributesArray = [];
      this.changeEntity(entity.eType);
      this.userstoryName = entity.eName;
      console.log(this.modelData.scopeMap);

      for (let map of this.modelData.scopeMap) {
        if (map.eID == entity.eID) {
          this.addAttr(map.aType);
        }
      }
    }
  }

  // resets all impacted selected fields
  resetImpactedTaskData() {
    this.selectedEUT = '';
    this.userstoryNameImpact = '';
  }


  // resets all user story selected fields
  resetTaskData() {
    this.selectedEntity = null;
    this.selectedAttributesArray = [];
    this.userstoryName = '';
    this.selectedEntityId = '';
    this.taskSelectedForModify = false;
    this.attrDisabled = false;
    this.selectedActivity = 'New';
    this.selectedEUT = '';
    this.selectedActivityObj = {
      type: 'TN',
      name: 'Test-NEW',
      shortfoam: 'New',
    };
    this.changeActivity(this.selectedActivityObj);
    $('#sprintPlannerListTable tr').removeClass('active');
    this.editTaskDetails = {};
  }

  //generation of unique id for userstory/entity
  uniqueID(type: any) {
    var model = this;
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return (
      type +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  }

}
